
  import createMeisterIcons from '../src/createMeisterIcons';

  const Monitor = createMeisterIcons("monitor", [["path",{"fill":"currentColor","d":"M7 3.75A3.26 3.26 0 0 0 3.75 7v6A3.26 3.26 0 0 0 7 16.25h10A3.26 3.26 0 0 0 20.25 13V7A3.26 3.26 0 0 0 17 3.75zM2.25 7A4.76 4.76 0 0 1 7 2.25h10A4.76 4.76 0 0 1 21.75 7v6A4.76 4.76 0 0 1 17 17.75h-4.25v2.5h3.75a.75.75 0 0 1 0 1.5h-9a.75.75 0 0 1 0-1.5h3.75v-2.5H7A4.76 4.76 0 0 1 2.25 13z","key":"171f9f017e9f4f31937b42746bd2726dabaf00c6","fillRule":"evenodd","clipRule":"evenodd"}]])

  export default Monitor
  